import React from 'react'
import { Box, Typography } from '@mui/material'

const TableHeader = ({ title, count }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, py: 0.5 }}>
    <Typography
      component="h4"
      sx={{
        fontSize: 17,
        fontWeight: 700,
        color: 'text.primary',
        letterSpacing: '-0.01em',
        margin: 0
      }}>
      {title}
    </Typography>
    {count !== undefined && count !== null ? (
      <Box
        sx={{
          px: 1.25,
          py: 0.25,
          borderRadius: '999px',
          backgroundColor: 'background.primary',
          color: 'text.disabled',
          fontSize: 13,
          fontWeight: 600,
          lineHeight: 1.6
        }}>
        {count}
      </Box>
    ) : null}
  </Box>
)

export default TableHeader
